import React, { useEffect, useState } from "react";
// React Table
import { Table } from "react-bootstrap";
// Styled Components
import styled from "styled-components";

import { entiendadesOtorgadorasExclaustracion, entiendadesOtorgadorasPermisoAusencia, tipoSituacionesParticularesObj } from "../../../contexto";
import { dateToString, dateToString2 } from "../../../utils";

const entidadOtorgadora = { ...entiendadesOtorgadorasExclaustracion, ...entiendadesOtorgadorasPermisoAusencia };

const CustomTd = styled.td`
  background-color: #eeeeee;
`;

const VistaSituacionParticular = ({ datosSituacionParticular }) => {
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  useEffect(() => {
    const typeLabelStartDate = () => {
      if (datosSituacionParticular.type === "Secularizacion") {
        return "Fecha de indulto";
      } else if (datosSituacionParticular.type === "Reingreso") {
        return "Fecha de reingreso";
      } else if (datosSituacionParticular.type === "PasoInstituto") {
        return "Fecha de transpaso";
      }
      return "Fecha inicio";
    };

    const typeLabelEndDate = () => {
      if (datosSituacionParticular.type === "Secularizacion") {
        return "Fecha de aceptación";
      }
      return "Fecha de término";
    };

    setStartDate(typeLabelStartDate());
    setEndDate(typeLabelEndDate());
  }, []);

  return (
    <Table bordered responsive>
      <tbody>
        <tr>
          <CustomTd className={"w-50"}>
            <span>{startDate}</span>
          </CustomTd>
          <td>{dateToString(datosSituacionParticular?.startDate) || <small>No especificado</small>}</td>
        </tr>
        {datosSituacionParticular.type !== "Reingreso" && datosSituacionParticular.type !== "PasoInstituto" && (
          <tr>
            <CustomTd>
              <span>{endDate}</span>
            </CustomTd>
            <td>{datosSituacionParticular?.endDate ? dateToString(datosSituacionParticular?.endDate) : "MDC (Mientras dure la causa)"}</td>
          </tr>
        )}
        {datosSituacionParticular?.cause && (
          <tr>
            <CustomTd>
              <span>Causa</span>
            </CustomTd>
            <td>{datosSituacionParticular?.cause || <small>No especificado</small>}</td>
          </tr>
        )}
        {datosSituacionParticular?.givenBy && (
          <tr>
            <CustomTd>
              <span>Otorgado por</span>
            </CustomTd>
            <td>{entidadOtorgadora[datosSituacionParticular?.givenBy] || <small>No especificado</small>}</td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

export default VistaSituacionParticular;
